import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Copy, Check } from 'lucide-react';
import { API } from '../../../lib/api';
import { inputCls } from './shared';

export const WarrantyPageSettings = ({ value, onChange, authHeader }) => {
  const [info, setInfo] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    axios.get(`${API}/billing/settings/warranty-embed`, { headers: authHeader() }).then((r) => setInfo(r.data)).catch(() => {});
  }, []); // eslint-disable-line
  const copy = async () => {
    try { await navigator.clipboard.writeText(info.embed_code); setCopied(true); setTimeout(() => setCopied(false), 2000); }
    catch { window.prompt('Copy this code:', info.embed_code); }
  };
  return (
    <div className="rounded-lg border border-slate-200 p-4 space-y-3" data-testid="warranty-page-settings">
      <div>
        <label className="block text-xs uppercase tracking-wider text-slate-500 mb-1">eWarranty page on your website</label>
        <input value={value} onChange={(e) => onChange(e.target.value)} placeholder="e.g. https://sharmamotors.in/warranty" className={inputCls} data-testid="warranty-page-url" />
        <div className="text-[10px] text-slate-400 mt-1">
          The QR code on your eWarranty certificates opens this page. Leave blank to use your standard verification page.
        </div>
      </div>
      {info && (
        <>
          <div>
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs uppercase tracking-wider text-slate-500">Paste this code on that page</span>
              <button type="button" onClick={copy} className="inline-flex items-center gap-1 text-xs font-semibold text-teal-700 hover:text-teal-900" data-testid="copy-embed-code">
                {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}{copied ? 'Copied' : 'Copy code'}
              </button>
            </div>
            <pre className="whitespace-pre-wrap break-all rounded-md bg-slate-900 p-3 text-[11px] text-teal-100" data-testid="embed-code">{info.embed_code}</pre>
            <div className="text-[10px] text-slate-400 mt-1">
              It shows a Warranty ID search box and, when opened from the QR, the warranty status, valid-until date, vehicle, service and customer name (partly hidden).
            </div>
          </div>
          <a href={info.hosted_page_url} target="_blank" rel="noreferrer" className="inline-block text-xs font-semibold text-teal-700 hover:text-teal-900" data-testid="hosted-verify-link">
            Preview your Driveline verification page →
          </a>
        </>
      )}
    </div>
  );
};
